import i18n from "i18next";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

i18n.use(Backend)
    .use(initReactI18next)
    .init({
        lng: 'en-US',
        fallbackLng: 'en-US',
        supportedLngs: ['en-US', 'en-CA', 'fr-CA'],
        load: 'currentOnly',
        debug: process.env.NODE_ENV === 'development',
        interpolation: {
            escapeValue: false // React already does escaping
        },
        backend: {
            loadPath: '/locales/{{lng}}/{{ns}}.json',
        }
    });

i18n.on('failedLoading', (lng, ns, msg) => {
    if (process.env.NODE_ENV === 'development')
        console.error(`Failed to load ${ns} namespace for ${lng}: ${msg}`);
});

export default i18n;